import React from 'react';

import SidebarMenu, { type SidebarMenuNode } from './sidebar-menu';

const items: SidebarMenuNode[] = [
  {
    key: 'translations',
    label: 'Translations',
    items: [
      {
        key: 'categoryLanguages',
        to: '/report/category-languages',
        label: 'Category languages',
      },
      {
        key: 'productLanguages',
        to: '/report/product-languages',
        label: 'Product languages',
      },
      {
        key: 'productMetaDescription',
        to: '/report/product-meta-description',
        label: 'Product meta description',
      },
      {
        key: 'productMetaKeywords',
        to: '/report/product-meta-keywords',
        label: 'Product meta keywords',
      },
      {
        key: 'propertyLanguages',
        to: '/report/property-languages',
        label: 'Property languages',
      },
      {
        key: 'propertyValueLanguages',
        to: '/report/property-value-languages',
        label: 'Property value languages',
      },
    ],
  },
  {
    key: 'warehouse',
    label: 'Warehouse',
    items: [
      {
        key: 'warehouseProductToImport',
        to: '/report/warehouse-product-to-import',
        label: 'Warehouse product to import',
      },
      {
        key: 'warehouseProductTrend',
        to: '/report/warehouse-product-trend',
        label: 'Warehouse product trend',
      },
      {
        key: 'warehouseCategoryTrend',
        to: '/report/warehouse-category-trend',
        label: 'Warehouse category trend',
      },
      {
        key: 'warehouseProductsPairing',
        to: '/report/warehouse-products-pairing',
        label: 'Warehouse products pairing',
      },
      {
        key: 'warehouseProductPhotoComparison',
        to: '/report/warehouse-product-photo-comparison',
        label: 'Product photos',
      },
    ],
  },
  {
    key: 'productQuality',
    label: 'Product quality',
    items: [
      {
        key: 'productScoring',
        to: '/report/product-scoring',
        label: 'Product scoring',
      },
      {
        key: 'photoDuplicates',
        to: '/report/photo-duplicates',
        label: 'Photo duplicates',
      },
      {
        key: 'productSafety',
        to: '/report/product-safety',
        label: 'Product safety gaps',
      },
      {
        key: 'productClaims',
        to: '/report/product-claims',
        label: 'Environmental claims',
      },
    ],
  },
  {
    key: 'finance',
    label: 'Finance',
    items: [
      { key: 'accounting', to: '/report/accounting', label: 'Accounting' },
      { key: 'oss', to: '/report/oss', label: 'OSS VAT' },
    ],
  },
  {
    key: 'conversion',
    label: 'Conversion',
    items: [
      {
        key: 'conversionFunnel',
        to: '/report/conversion-funnel',
        label: 'Conversion funnel',
      },
    ],
  },
  {
    key: 'webAnalytics',
    label: 'Web analytics',
    items: [
      {
        key: 'webAnalyticsInsights',
        to: '/report/web-analytics-insights',
        label: 'Web analytics insights',
      },
      {
        key: 'webAnalyticsRecommendations',
        to: '/web-analytics/recommendations',
        label: 'Recommendations',
      },
    ],
  },
];

function SidebarReport(): React.ReactElement {
  return <SidebarMenu items={items} />;
}

export default SidebarReport;
